import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return <h1 className="title-comparador-component">Comparador</h1>;
};

export default TitleComponent;
